import { REVALIDATE_PERIOD } from '@/_constants/env';
import { isrFetch } from '@/api/utils/isr-fetch';
import { nativeFetch } from '@/api/utils/native-fetch';
import { URL_PATH } from './constants';
import { TCategoryServerResponse, TGetCategoryRequestProps } from './_types';

export const getCategory = async ({
  url,
  id,
  language,
  slug,
  country,
  isIsr = true,
}: TGetCategoryRequestProps): Promise<TCategoryServerResponse | null> => {
  const params = {
    url: `${url}${URL_PATH}`,
    body: JSON.stringify({
      method: 'one',
      params: { id: slug || id, language, region: country },
      jsonrpc: '2.0',
    }),
  };

  if (isIsr) {
    return isrFetch({
      ...params,
      revalidate: REVALIDATE_PERIOD,
    });
  }

  return nativeFetch(params);
};
